import React from "react";

interface AIResponseContentProps {
  destination?: string;
  userInput: string;
}

const AIResponseContent: React.FC<AIResponseContentProps> = ({
  destination,
  userInput,
}) => {
  if (destination) {
    return (
      <p>
        Great! I can help you plan your trip to{" "}
        <span className="font-semibold">{destination}</span>.
      </p>
    );
  }

  return (
    <p>
      Thank you for your question about{" "}
      <span className="font-semibold">"{userInput}"</span>. I'm processing your
      request and will provide you with detailed travel information soon.
    </p>
  );
};

export default AIResponseContent;
